module.exports = __webpack_public_path__ + "static/images/cover_A1.6e0ff8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cover/cover_A1.png
// module id = lelj
// module chunks = 8